import { render, staticRenderFns } from "./tearchList.vue?vue&type=template&id=6ab96168&scoped=true"
import script from "./tearchList.vue?vue&type=script&lang=js"
export * from "./tearchList.vue?vue&type=script&lang=js"
import style0 from "./tearchList.vue?vue&type=style&index=0&id=6ab96168&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab96168",
  null
  
)

export default component.exports